// extracted by mini-css-extract-plugin
export default {"shareSocials":"ShareSocials_shareSocials__cK+Bu"};